import { Link, useParams } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { MdxBody } from "@/components/MdxBody";
import { bySlug, thinking } from "@/lib/content/load";
import { formatDate } from "@/lib/dates";
import { headingText } from "@/lib/heading";
import { sourceLabel } from "@/features/editorial/filters";
import { NotFoundPage } from "./NotFoundPage";

export function ThinkingDetailPage() {
  const { slug = "" } = useParams();
  const record = bySlug(thinking, slug);
  if (!record) return <NotFoundPage />;
  const { meta, Component } = record;
  const linkedin = meta.type === "linkedin-highlight";

  return (
    <>
      <Seo
        title={meta.title}
        description={meta.seoDescription}
        path={meta.canonicalPath}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Article",
          headline: meta.title,
          datePublished: meta.originalPublishedAt ?? meta.sitePublishedAt,
          dateModified: meta.lastReviewedAt,
          author: { "@type": "Person", name: meta.originalAuthor },
        }}
      />
      <article className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">{sourceLabel(meta.type)}</p>
        <h1>{headingText(meta.title)}</h1>
        <p className="meta">
          {linkedin && meta.originalPublishedAt
            ? `LinkedIn · ${formatDate(meta.originalPublishedAt)}`
            : formatDate(meta.sitePublishedAt)}
        </p>
        {linkedin && meta.sourceUrl ? (
          <p>
            <a href={meta.sourceUrl}>On LinkedIn</a>
          </p>
        ) : null}
        <MdxBody Component={Component} />
        <p>
          <Link to="/thinking">All thinking</Link>
        </p>
      </article>
    </>
  );
}
